import Tabs from '@/components/Tabs/Tabs';
import styles from './GenerateTexture.module.less';
import { useEffect, useRef, useState } from 'react';
import uploadIcon from '@/assets/home/upload.png';
import modelImg from '@/assets/home/modelImg.png';

import { Input, Upload } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { SDService, projectController } from '@/api';
import UploadProgress from '@/components/UploadProgress/UploadProgress';
import GLBViewer from '@/components/GLBViewer/GLBViewer';
import Uploader from '@/utils/uppyUpload';
import toast from 'react-hot-toast';
import { base64ToFile, fileExtension, isFormatFile } from '@/utils/file';
import ConfirmDialog from '@/components/ConfirmDialog/ConfirmDialog.jsx';
import { useDispatch, useSelector } from 'react-redux';
import { setShowPricePage } from '@/store/slices/home.js';
import jsFunc from '@/utils/jsFunc';
import message, { info } from '@/utils/message';
import { reportData } from '@/utils/trackingPoint';
let interval = null;
export default function Home(props) {
  const [tab, setTab] = useState(0);
  const [imageFileInfo, setImageFileInfo] = useState(null);
  const [imageURL, setImageURL] = useState(null);
  const [meshFile, setMeshFile] = useState(null);
  const [inputText, setInputText] = useState(null);

  const [showBanlanceModal, setShowBanlanceModal] = useState(false);
  const dispatch = useDispatch();

  const [progress, setProgress] = useState(0);
  const [uploading, setUploading] = useState(false);
  const [uploadLoading, setUploadLoading] = useState(false);
  const glbViewerRef = useRef(null);
  const modelResult = useRef(null);
  const [preProjectId, setPreProjectId] = useState(null);
  const [creating, setCreating] = useState(false);
  const uploader = useRef(null);

  const testTaskId = false; // 走测试id

  const navigate = useNavigate();

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const name = query.get('register');
    if (!window.reportDataGoogle) {
      if (name === 'true') {
        reportData('signup-google-success');
      } else if (name === 'false') {
        reportData('login-google-success');
      }
      window.reportDataGoogle = true;
    }
    return () => {
      console.log('组件销毁');
      if (uploader.current != null) {
        console.log('销毁执行');
        uploader.current.stop();
        uploader.current = null;
      }
    };
  }, []);

  // 截图 -> base64
  const snapshotBase64 = (mime = 'image/png', quality) => {
    // 需要在 renderer 初始化时设置 preserveDrawingBuffer:true 才能截图
    const dataURL = document.getElementById('glbViewer').toDataURL(mime, quality); // 'data:image/png;base64,...'
    // 如果你只要纯 base64（无前缀）：
    const base64 = dataURL.split(',')[1];
    return { dataURL, base64 };
  };

  const uploadFile = (file, type) => {
    const fileExtension = file.name.split('.').pop();
    return new Promise((reslove, reject) => {
      uploader.current = new Uploader(type, { ext: fileExtension });
      uploader.current.onComplete = async (result) => {
        reslove(result);
      };
      uploader.current.uploadFileWithSlice(file);
    });
  };

  // 上传mesh
  const uploadMesh = async (meshFile) => {
    reportData('home-start-texture');

    if (uploadLoading) {
      info('Waiting for generation to complete');
      return;
    }
    if (!meshFile) {
      info('Please choose file');
      return;
    }

    setMeshFile(meshFile);
    // navigate('/textureUnity');
    // return;
    const fileExtension = meshFile.name.split('.').pop();
    const fileName = meshFile.name.split('.')[0];
    const startTime = new Date().getTime();
    // const coverimg = glbViewerRef.current.snapshotBase64();
    modelResult.current = null;
    setUploadLoading(true);
    let p = 0;
    if (interval != null) {
      clearInterval(interval);
      setProgress(0);
    }
    interval = setInterval(() => {
      p = p + 2;
      setProgress(p);
    }, 80);

    modelResult.current = await uploadFile(meshFile, 0);

    clearInterval(interval);

    setUploadLoading(false);
    if (uploader.current) {
      preCreate(meshFile);
    }

    // const coverimgResult = await uploadFile(base64ToFile(coverimg, 'cover.jpg'), 1);
  };

  // 预创建项目
  const preCreate = async (meshFile) => {
    const fileName = meshFile.name.split('.')[0];

    const { uploadId, eTags } = modelResult.current;
    let type = 0;
    if (fileExtension === 'obj') {
      type = 0;
    } else if (fileExtension === 'fbx') {
      type = 1;
    } else if (fileExtension === 'glb') {
      type = 2;
    }

    const res = await projectController.createPreProject({
      body: {
        name: fileName,
        stream: {
          type: type, // StreamTypeEnum
          upload: {
            uploadId: uploadId,
            completedParts: eTags,
          },
          zIndex: 1,
        },

        type: 0, // ProjectTypeEnum
        mode: 'texture', // ConsumptionMode
        tempId: '',
      },
    });

    if (res.code === 0) {
      // 创建成功
      reportData('upload-model-success');
      console.log('PreProjectId', res.data);
      setPreProjectId(res.data);
    }
  };

  // 上传mesh
  const create = async () => {
    if (!modelResult.current || !preProjectId || creating) {
      return;
    }
    try {
      setCreating(true);
      const fileName = meshFile.name.split('.')[0];

      const { uploadId, eTags } = modelResult.current;
      let type = 0;
      if (fileExtension === 'obj') {
        type = 0;
      } else if (fileExtension === 'fbx') {
        type = 1;
      } else if (fileExtension === 'glb') {
        type = 2;
      }

      const res = await projectController.create({
        body: {
          name: fileName,
          projectId: preProjectId,
          stream: {
            type: type, // StreamTypeEnum
            upload: {
              uploadId: uploadId,
              completedParts: eTags,
            },
            zIndex: 1,
          },
          type: 0, // ProjectTypeEnum
          mode: 'texture', // ConsumptionMode
          tempId: '',
        },
      });

      if (res.code === 0) {
        // 创建成功
        reportData('upload-model-success');

        const { projectId, url } = res.data;
        console.log(res);
        sessionStorage.setItem('texture_model_url', url);
        setUploadLoading(false);
        window.location.href =
          window.location.protocol + '//' + window.location.host + '/texture/' + projectId;
      }
      // setCreating(false);
    } catch (error) {
      console.error(error);
      setCreating(false);
    }
  };

  return (
    <div className={styles['container']}>
      <div className={styles['caption']}>Generate Texture</div>
      <Upload
        beforeUpload={() => false}
        showUploadList={false}
        accept=".glb,.obj,.fbx"
        onChange={(info) => {
          reportData('upload-model');
          const isLt2M = info.file.size / 1024 / 1024 < 70;
          if (!isLt2M) {
            message.info('Please upload a file smaller than 70MB');
            return;
          }
          if (isFormatFile(info.file, ['.glb', '.obj', '.fbx'])) {
            uploadMesh(info.file);
          } else {
            message.info('Invalid format');
          }
        }}>
        {meshFile ? (
          <div className={styles['texure-tab-content']}>
            {!uploadLoading ? <img className={styles['model-img']} src={modelImg} /> : <></>}
            {/* <GLBViewer
                key={meshFile.name}
                ref={glbViewerRef}
                format={fileExtension(meshFile.name)}
                onLoadFinish={() => {}}
                style={{ width: '100%', height: '100%' }}
                url={URL.createObjectURL(meshFile)}></GLBViewer> */}

            {uploadLoading ? (
              <div className={styles['texure-tab-content-upload']}>
                <UploadProgress
                  imageSize="small"
                  percent={progress}
                  hideTitle={true}></UploadProgress>
              </div>
            ) : (
              <></>
            )}
          </div>
        ) : (
          <div className={styles['texure-tab-content']}>
            <img className={styles['icon']} src={uploadIcon}></img>
            <div className={styles['desc']}>
              <span style={{ color: '#A0F00F', textDecoration: 'underline' }}>Click to upload</span>
              <span> or drag and drop</span>
            </div>
            <div className={styles['suffix']}>
              <span>OBJ, FBX and GLB formats. Less than 70MB.</span>
            </div>
          </div>
        )}
      </Upload>

      <div
        className={`${styles['start-btn']}  ${modelResult.current && preProjectId ? styles['enable'] : null}`}
        onClick={create}>
        {creating ? 'Uploading...' : 'Upload model'}
      </div>

      {showBanlanceModal && (
        <ConfirmDialog
          confirmTitle="Confirm to recharge"
          content="Insufficient balance, please recharge."
          onConfirm={() => {
            dispatch(setShowPricePage(true));
            setShowBanlanceModal(false);
            props?.onCancel();
          }}
          onCancel={() => {
            if (interval != null) {
              clearInterval(interval);
              setProgress(0);
            }
            setShowBanlanceModal(false);
          }}></ConfirmDialog>
      )}
    </div>
  );
}
